// src/pages/AuthPage/ForgotPassword.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { requestPasswordReset } from '../../api/userApi';
import { useToast } from '../../components/Toaster/use-toast';
import { ArrowLeft } from 'lucide-react';
import './AuthCards.css';
import Input from '../../components/Input/Input';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [touched, setTouched] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const validateEmail = (v) => {
    const val = (v || '').trim();
    if (!val) return 'Email is required';
    if (!EMAIL_RE.test(val)) return 'Enter a valid email address';
    return '';
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const err = validateEmail(email);
    setEmailErr(err);
    setTouched(true);
    if (err) return;

    try {
      setSubmitting(true);
      await requestPasswordReset(email.trim());
      setDone(true);
      toast({
        title: 'Check your email',
        description: 'If an account exists, we sent a link to reset your password.',
      });
    } catch {
      // same UX to avoid user enumeration
      setDone(true);
      toast({
        title: 'Check your email',
        description: 'If an account exists, we sent a link to reset your password.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-card-head">
          <h1 className="auth-title">Forgot your Password?</h1>
          <p className="auth-subtitle">We’ll email you a secure reset link.</p>
        </div>

        {!done ? (
          <form className="auth-form" onSubmit={onSubmit} noValidate>
            <div className="input-icon-wrap">
              <Input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => {
                  const v = e.target.value;
                  setEmail(v);
                  if (touched) setEmailErr(validateEmail(v)); // live-clear after first blur/submit
                }}
                onBlur={() => {
                  setTouched(true);
                  setEmailErr(validateEmail(email));
                }}
                required
                error={touched && !!emailErr}
                errorText={touched ? emailErr : ''}
              />
            </div>

            <button
              className="auth-btn primary"
              disabled={submitting || !!validateEmail(email)}
            >
              {submitting ? 'Sending…' : 'Send Reset Link'}
            </button>
          </form>
        ) : (
          <div className="auth-success">
            <p>
              If we found an account for <strong>{email}</strong>, you’ll get an email with a reset link shortly.
            </p>
            <button className="auth-btn primary" onClick={() => navigate('/auth')}>
              Back to Sign In
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
